import React from 'react';
import styles from 'styles/empty_state.module.scss';
import { Button } from 'components';
import useReactRouter from 'use-react-router';

const EmptyState = ({ heading, children, Illustration, action = false, secondaryAction = false, background }) => {
	const { history, location } = useReactRouter();
	return (
		<div className={styles.EmptyState} style={{ background }}>
			<Illustration className={styles.illustration} />
			<div className={styles.details}>
				<h2>{heading}</h2>
				{children}
				{action && <Button {...action} onClick={() => history.push(action.url + location.search)} />}
				{secondaryAction && (
					<Button {...secondaryAction} onClick={() => history.push(action.url + location.search)} />
				)}
			</div>
		</div>
	);
};

export default EmptyState;
